import { useEffect, useState } from "react";
import { Box, HBox } from "../box/Box";
import { InfoButton } from "../info/InfoButton";

export const Checkbox = (params: {
	name?: string;
	label?: string;
	disabled?: boolean;
	data?: any;
	onChange?: (checked: boolean) => void;
	sx?: React.CSSProperties;
	size?: "small" | "medium";
	description?: string;
	checked?: boolean;
}) => {
	const [checked, setChecked] = useState<boolean>(
		params.checked !== undefined
			? params.checked
			: params.data && typeof params.data === "object" && params.name && typeof params.name === "string"
			? params.data[params.name]
			: false
	);

	useEffect(() => {
		if (params.checked !== undefined) {
			setChecked(params.checked);
		}
	}, [params.checked]);

	const size = params.size || "medium";

	let boxSize = 20;
	if (size === "small") boxSize = 15;

	const toggleChecked = () => {
		const newVal = !checked;
		setChecked(newVal);
		if (params.data && typeof params.data === "object" && params.name && typeof params.name === "string") params.data[params.name] = newVal;
		if (params.onChange) params.onChange(newVal);
	};

	const indicator = (
		<Box
			sx={{
				flexShrink: "0",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "column",
				border: checked ? "1px solid #2B5C8A" : "1px solid rgba(0,0,0,.25)",
				borderRadius: "5px",
				backgroundColor: checked ? "#2B5C8A" : "#FFFFFF",
				transition: "background-color .2s, border .2s",
				width: `${boxSize}px`,
				height: `${boxSize}px`,
				pointerEvents: "none",
			}}>
			{checked && (
				<svg width={Math.round(boxSize * 0.65)} height={Math.round(boxSize * 0.65)} viewBox="0 0 12 12" fill="none" aria-hidden="true">
					<path d="M2 6.2 4.5 8.6 10 3" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			)}
		</Box>
	);

	const control = (
		<Box
			element="button"
			type="button"
			role="checkbox"
			aria-checked={checked}
			aria-label={params.label ?? params.name ?? "Checkbox"}
			disabled={params.disabled}
			onClick={toggleChecked}
			sx={{
				display: "flex",
				gap: params.label ? "12px" : "0",
				alignItems: "center",
				minHeight: "32px",
				padding: "0",
				border: "0",
				backgroundColor: "transparent",
				color: "inherit",
				font: "inherit",
				textAlign: "left",
				cursor: params.disabled ? "default" : "pointer",
				borderRadius: "8px",
				"&:hover>div:first-child": { border: params.disabled ? undefined : "1px solid #35539f" },
				"&:focus-visible": { outline: "3px solid rgba(37, 99, 235, 0.18)", outlineOffset: "2px" },
				"@media (pointer: coarse)": { minHeight: "44px" },
			}}>
			{indicator}
			{params.label && (
				<Box
					element="span"
					sx={{
						fontSize: params.sx ? ".88rem" : "11px",
						whiteSpace: params.sx ? "preserve-breaks" : undefined,
						...params.sx,
					}}>
					{params.label}
				</Box>
			)}
		</Box>
	);

	if (!params.description) return control;

	return (
		<HBox sx={{ alignItems: "center", gap: "10px" }}>
			{control}
			<InfoButton text={params.description} />
		</HBox>
	);
};
